// TODO: use proper logger
const logger = console;

export const getLogger = () => {
    return logger;
};
